/* eslint-disable default-case */
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  IconButton,
  LinearProgress,
  Menu,
  MenuItem,
  TextField,
  InputAdornment,
  Divider,
  Autocomplete,
} from "@mui/material";
import {
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  InsertDriveFile as FileIcon,
  CloudUpload,
  Delete,
  CreateNewFolder,
  ArrowBack,
  Search,
  Upload,
  Download,
  DriveFolderUpload,
  ArrowCircleUp,
  Check,
} from "@mui/icons-material";
import { useDropzone } from "react-dropzone";

import { useLocation } from "react-router-dom";
import {
  deleteMutiFileFolder,
  downloadFileFast,
  fileDownloadStatusUpdate,
  filefolderGetFreelanceJobs,
  fileManagerPaste,
  fileManagerUpdate,
  getFileMangerList,
  getFilesCountForSingleScoop,
  getScoopFileFolders,
  Newfoldermake,
  copyScoopFilesToScoop,
  globalSearchProjectHeader,
} from "../redux/Thunk/DashboardModule/DashboardThunk";
import { useDispatch, useSelector } from "react-redux";
import authApi from "../redux/authApi";
import FilePropertiesDialog from "./Ui_elements/FilePropertiesDialog";
import { Backdrop, CircularProgress } from "@mui/material";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { formatDateTime } from "./formateDate";
import Loader from "./Ui_elements/Loader";
import PopupModal from "./Ui_elements/PopupModal";

const CHUNK_SIZE = 5 * 1024 * 1024;
const CONCURRENCY = 5;
const CHUNK_RETRIES = 3;

const FileManagerFastUpload = () => {
  const dispatch = useDispatch();
  const { file_folders } = useSelector(state => state.root.DashboardModule);
  const { iFkUserTypeId } = useSelector(state => state?.root?.authUser?.user || {});
  const { loading } = useSelector(state => state.root.loading);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const scoopId = searchParams.get("scoopId");
  const jobId = searchParams.get("jobId");
  const sourceTargetType = searchParams.get("sourceTargetType");
  const jobTemplateId = searchParams.get("jobTemplateId");
  const clientId = searchParams.get("clientId");
  const inClientId = searchParams.get("inClientId");
  const userId = searchParams.get("userId");
  const jobParams = {
    jobId,
    sourceTargetType,
  };
  const [currentPath, setCurrentPath] = useState([]);
  const [expandedFolders, setExpandedFolders] = useState(new Set());
  const [files, setFiles] = useState([]);
  const [fileStructure, setFileStructure] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [copiedIds, setCopiedIds] = useState([]);
  const [isUploadOpen, setIsUploadOpen] = useState(true);
  const [copyToScoopOpen, setCopyToScoopOpen] = useState(false);
  const [destScoop, setDestScoop] = useState(null);
  const [destScoopOptions, setDestScoopOptions] = useState([]);
  const abortRef = useRef({});
  const destSearchTimeoutRef = useRef(null);

  useEffect(() => {
    if (window.opener && typeof window.opener.refreshFileManagerCount === "function") {
      window.opener.refreshFileManagerCount();
    }
  }, [file_folders]);

  const handleContextMenu = (e, item, isJobView = false) => {
    e.preventDefault();
    e.stopPropagation();
    setMenuAnchor({ mouseX: e.clientX + 2, mouseY: e.clientY - 6, item, isJobView });
    if (!selectedIds?.includes(item?.fmanager_id)) {
      handleItemSelection(e, item?.fmanager_id);
    }
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };
  const handleFolderDownload = async (folderId, folderName = "TMS_") => {
    const zip = new JSZip();
    const missingFiles = [];
    const fileNameMap = {};

    try {
      const response = await authApi.get(`/filemanagerfolderDownload/${folderId}`);
      const rootData = response.data.data;

      const sanitizeName = name => name.replace(/[<>:"/\\|?*]/g, "_");

      const getUniqueName = (name, folderPath) => {
        const key = folderPath + "/" + name;
        if (!fileNameMap[key]) {
          fileNameMap[key] = 1;
          return name;
        } else {
          const ext = name.includes(".") ? name.split(".").pop() : "";
          const base = name.replace(/\.[^/.]+$/, "");
          const newName = `${base}(${fileNameMap[key]++}).${ext}`;
          return newName;
        }
      };

      const addToZipRecursively = async (node, zipFolder, currentPath = "") => {
        if (node.children && node.children.length > 0) {
          const folderName = sanitizeName(node.name || "Unnamed");
          const nextFolder = zipFolder.folder(folderName);
          const nextPath = currentPath + "/" + folderName;
          for (let child of node.children) {
            await addToZipRecursively(child, nextFolder, nextPath);
          }
        } else if (node.ext && node.ext !== "") {
          try {
            const fileUrl = node.name;
            let fileName = sanitizeName(
              node.original_filename || `file_${node.fmanager_id}.${node.ext}`
            );
            fileName = getUniqueName(fileName, currentPath);

            const res = await fetch(`${fileUrl}?cache_buster=${Date.now()}`);
            if (!res.ok) throw new Error(`Fetch failed: ${fileUrl}`);

            const blob = await res.arrayBuffer();
            zipFolder.file(fileName, blob);
          } catch (error) {
            console.warn(`Missing or failed: ${node.original_filename}`, error);
            missingFiles.push(node.original_filename);
          }
        }
      };

      await addToZipRecursively(rootData, zip);

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, `${folderName}.zip`);

      if (missingFiles.length > 0) {
        alert(`Some files couldn't be downloaded:\n${missingFiles.join("\n")}`);
      }
    } catch (error) {
      console.error("Failed to download folder:", error);
      alert("Failed to download folder. Please try again.");
    }
  };

  const handleFastDownload = async item => {
    const fmanagerId = item?.fmanager_id;
    const originalFilename = item?.original_filename;

    if (!fmanagerId) return;

    const apiBase = authApi?.defaults?.baseURL || "";
    const endpoint = `${apiBase.replace(/\/$/, "")}/downloadFileFast/${fmanagerId}`;

    try {
      const token = localStorage.getItem("token");
      const headers = { Accept: "application/json" };
      if (token) headers.Authorization = `Bearer ${token}`;

      const res = await fetch(endpoint, { method: "GET", headers });

      if (!res.ok) {
        let errMsg = `Download failed (HTTP ${res.status})`;
        try {
          const maybeJson = await res.json();
          errMsg = maybeJson?.msg || maybeJson?.error?.msg || errMsg;
        } catch (_) {}
        throw new Error(errMsg);
      }

      const contentType = (res.headers.get("content-type") || "").toLowerCase();

      // Presigned URL mode: backend returns JSON.
      if (contentType.includes("application/json")) {
        const data = await res.json();
        if (data?.download_url) {
          window.open(data.download_url, "_blank");
        } else {
          throw new Error("Invalid fast download response");
        }
      } else {
        // Streaming mode fallback: backend returned the binary file.
        const blob = await res.blob();
        const contentDisposition = res.headers.get("content-disposition") || "";
        const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i);
        const downloadName = match?.[1] || originalFilename || "download";

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", downloadName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(url), 10000);
      }

      iFkUserTypeId === 2 &&
        jobId &&
        dispatch(
          fileDownloadStatusUpdate({
            fmanager_id: fmanagerId,
            jobId,
          })
        );
    } catch (error) {
      console.error("Fast download error:", error);
      alert(error?.message || "Failed to download file.");
    }
  };

  const handleMenuAction = action => {
    switch (action) {
      case "open":
        handleFolderDoubleClick(menuAnchor?.item);
        break;
      case "delete":
        if (!selectedIds?.length) {
          window.alert("No files selected");
        } else if (window.confirm("Are you sure you want to delete this item?"))
          dispatch(deleteMutiFileFolder({ payload: selectedIds, scoopId })).then(() => {
            jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
            clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
            inClientId &&
              dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
            userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
            jobTemplateId &&
              dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
          });
        break;
      case "refresh":
        scoopId && dispatch(getScoopFileFolders(scoopId));
        jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
        clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
        inClientId && dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
        userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
        jobTemplateId &&
          dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
        break;
      case "copy":
        setCopiedIds(selectedIds);
        break;
      case "copyFolder":
        setCopiedIds([menuAnchor?.item?.fmanager_id]);
        break;
      case "paste":
        const payload = copiedIds?.map(s => ({ id: s, parent_id: currentPath?.at?.(-1) }));
        if (copiedIds?.length)
          dispatch(fileManagerPaste({ payload, scoopId })).then(() => {
            jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
            clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
            inClientId &&
              dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
            userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
            jobTemplateId &&
              dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
          });
        break;
      case "download":
        if (menuAnchor?.item?.categories) {
          handleFolderDownload(menuAnchor?.item?.fmanager_id, menuAnchor?.item?.name);
        } else {
          dispatch(
            downloadFileFast({
              fmanager_id: menuAnchor?.item?.fmanager_id,
              original_filename: menuAnchor?.item?.original_filename,
            })
          ).then(() => {
            iFkUserTypeId === 2 &&
              jobId &&
              dispatch(
                fileDownloadStatusUpdate({
                  fmanager_id: menuAnchor?.item?.fmanager_id,
                  jobId,
                })
              );
          });
        }
        break;
      case "fast_download":
        if (menuAnchor?.item?.categories) {
          handleFolderDownload(menuAnchor?.item?.fmanager_id, menuAnchor?.item?.name);
        } else {
          handleFastDownload(menuAnchor?.item);
        }
        break;
      case "rename":
        const newName = prompt(
          "Please enter name",
          menuAnchor?.item?.categories
            ? menuAnchor?.item?.name
            : menuAnchor?.item?.original_filename
        );
        if (newName)
          dispatch(
            fileManagerUpdate({
              id: menuAnchor?.item?.fmanager_id,
              payload: { name: newName },
              scoopId,
            })
          ).then(() => {
            jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
            clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
            inClientId &&
              dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
            userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
            jobTemplateId &&
              dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
          });
    }
    handleCloseMenu();
  };

  const [jobs, setJobs] = useState([]);
  useEffect(() => {
    jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
    clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
    inClientId && dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
    userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
    jobTemplateId && dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
    if (scoopId) {
      dispatch(getScoopFileFolders(scoopId));
      dispatch(filefolderGetFreelanceJobs(scoopId)).then(({ payload }) => {
        setJobs(payload.data);
      });
    }
  }, []);

  useEffect(() => {
    if (file_folders) {
      setFileStructure([file_folders]);
      handleFolderDoubleClick(file_folders);
      let current = [file_folders];
      for (const id of currentPath) {
        const found = current.find(item => item.fmanager_id === id);
        if (found && found.categories) {
          current = found.categories;
        } else {
          break;
        }
      }
      setCurrentItems(current);
    }
  }, [file_folders, currentPath]);

  const handleItemSelection = (e, id) => {
    const isCtrlPressed = e.ctrlKey || e.metaKey;
    setSelectedIds(prev => {
      if (isCtrlPressed) {
        return prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id];
      } else {
        return [id];
      }
    });
  };

  const handleFolderClick = (e, folderId) => {
    const isCtrlPressed = e.ctrlKey || e.metaKey;
    if (!isCtrlPressed)
      setTimeout(() => {
        setExpandedFolders(prev => {
          const newExpanded = new Set(prev);
          if (newExpanded.has(folderId)) {
            newExpanded.delete(folderId);
          } else {
            newExpanded.add(folderId);
          }
          return newExpanded;
        });
      }, 200);
  };

  function findPathByFmanagerId(node, targetId, path = []) {
    if (!node) return null;
    const newPath = [...path, node.fmanager_id];
    if (node.fmanager_id === targetId) return newPath;
    if (Array.isArray(node.categories)) {
      for (const child of node.categories) {
        const result = findPathByFmanagerId(child, targetId, newPath);
        if (result) return result;
      }
    }
    return null;
  }

  const handleFolderDoubleClick = folder => {
    if (!currentPath.includes(folder.fmanager_id))
      setCurrentPath(findPathByFmanagerId(file_folders, folder?.fmanager_id));
    if (folder.categories && folder.categories.length > 0) {
      setCurrentItems(folder.categories);
    } else {
      setCurrentItems([]);
    }
    const newExpanded = new Set(expandedFolders);
    newExpanded.add(folder.fmanager_id);
    setExpandedFolders(newExpanded);
  };

  const moveUpDirectory = () => {
    if (currentPath.length === 1) return;
    setExpandedFolders(new Set());
    const newPath = [...currentPath];
    newPath.pop();
    setCurrentPath(newPath);

    if (newPath.length === 0) {
      setCurrentItems(fileStructure);
    } else {
      let current = fileStructure;
      for (const id of newPath) {
        const found = current.find(item => item.fmanager_id === id);
        if (found && found.categories) {
          current = found.categories;
        } else {
          break;
        }
      }
      setCurrentItems(current);
    }
  };

  const renderFolder = ({ item, depth = 1, isJobView = false }) => {
    const isExpanded = expandedFolders.has(item.fmanager_id);
    const hasChildren = item.categories && item.categories.length > 0;

    return (
      <React.Fragment key={item.fmanager_id}>
        <ListItem
          button
          onClick={e => handleFolderClick(e, item.fmanager_id)}
          onDoubleClick={() => !isJobView && handleFolderDoubleClick(item)}
          onContextMenu={e => !isJobView && handleContextMenu(e, item)}
          sx={{
            pl: depth * 2,
            userSelect: "none",
            bgcolor: selectedIds.includes(item.fmanager_id) ? "grey.200" : "",
            "&:hover": {
              bgcolor: selectedIds.includes(item.fmanager_id) ? "grey.200" : "grey.100",
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: "40px" }}>
            {isExpanded ? <FolderOpenIcon color="primary" /> : <FolderIcon color="primary" />}
          </ListItemIcon>
          <ListItemText
            sx={{ overflowWrap: "anywhere" }}
            primary={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {item.name}{" "}
                <Typography
                  sx={{
                    bgcolor: "primary.light",
                    opacity: 0.6,
                    color: "#fff",
                    fontWeight: "500",
                    borderRadius: "20px",
                    padding: "0 5px",
                    minWidth: "16px",
                    lineHeight: "16px",
                    fontSize: "11px",
                    textAlign: "center",
                  }}
                >
                  {item?.categories?.length}
                </Typography>
              </Box>
            }
          />
        </ListItem>

        {hasChildren && (
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.categories.map(child =>
                child.categories
                  ? renderFolder({ item: child, depth: depth + 1, isJobView })
                  : renderFile({ item: child, depth: depth + 1, isJobView })
              )}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  const renderFile = ({ item, depth = 1, isJobView = false }) => {
    return (
      <ListItem
        key={item.fmanager_id}
        sx={{
          pl: depth * 2,
          userSelect: "none",
          bgcolor: selectedIds.includes(item.fmanager_id) ? "grey.200" : "",
          "&:hover": { bgcolor: selectedIds.includes(item.fmanager_id) ? "grey.200" : "grey.100" },
        }}
        onClick={e => !isJobView && handleItemSelection(e, item?.fmanager_id)}
        onContextMenu={e => handleContextMenu(e, item, isJobView)}
        onDoubleClick={() =>
          dispatch(
            downloadFileFast({
              fmanager_id: item?.fmanager_id,
              original_filename: item?.original_filename,
            })
          ).then(() => {
            iFkUserTypeId === 2 &&
              jobId &&
              dispatch(
                fileDownloadStatusUpdate({
                  fmanager_id: item?.fmanager_id,
                  jobId,
                })
              );
          })
        }
      >
        <ListItemIcon sx={{ minWidth: "40px" }}>
          <FileIcon color="info" />
        </ListItemIcon>
        <ListItemText
          sx={{ overflowWrap: "anywhere" }}
          primary={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {item.original_filename || item.name}{" "}
              <Typography variant="caption" color="grey.700">
                ({item.size || "File"})
              </Typography>
              <IconButton
                onClick={() =>
                  dispatch(
                    downloadFileFast({
                      fmanager_id: item?.fmanager_id,
                      original_filename: item?.original_filename,
                    })
                  ).then(() => {
                    iFkUserTypeId === 2 &&
                      jobId &&
                      dispatch(
                        fileDownloadStatusUpdate({
                          fmanager_id: item?.fmanager_id,
                          jobId,
                        })
                      );
                  })
                }
              >
                <Download sx={{ fontSize: "16px", color: "primary.main", cursor: "pointer" }} />
              </IconButton>
            </Box>
          }
          secondary={` ${formatDateTime(item.created_date, true)}` || "File"}
        />
        {item?.is_download === 1 && iFkUserTypeId !== 2 && (
          <Box
            sx={{
              backgroundColor: theme => theme.palette.success.main,
              color: "#fff",
              borderRadius: "10px",
              height: "20px",
              width: "20px",
              textAlign: "center",
            }}
          >
            <Check sx={{ fontSize: "12px" }} />
          </Box>
        )}
      </ListItem>
    );
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop: useCallback(acceptedFiles => {
      const newEntries = acceptedFiles.map(file => ({
        file,
        progress: 0,
        status: "ready",
        upload: null,
      }));
      setFiles(curr => [...curr, ...newEntries]);
    }, []),
    noClick: true,
    noKeyboard: true,
    multiple: true,
  });

  const removeFile = idx => {
    if (abortRef.current[idx]) {
      abortRef.current[idx].abort();
    }
    setFiles(curr => curr.filter((_, i) => i !== idx));
  };

  const uploadChunkWithRetry = async (formData, onProgress, signal) => {
    for (let attempt = 1; attempt <= CHUNK_RETRIES; attempt++) {
      try {
        await authApi.post("/saveFileUploadFastChunk", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: onProgress,
          signal,
        });
        return;
      } catch (err) {
        if (err.name === "CanceledError" || err.name === "AbortError") throw err;
        if (attempt === CHUNK_RETRIES) throw err;
      }
    }
  };

  const uploadAll = () => {
    files.forEach((entry, idx) => {
      if (entry.status !== "ready") return;

      setFiles(curr =>
        curr.map((f, i) => (i === idx ? { ...f, status: "uploading", progress: 0 } : f))
      );

      const file = entry.file;
      const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
      const uploadId = `${Date.now()}_${Math.random().toString(36).slice(2)}`;
      const chunkLoaded = {};
      const updateProgress = () => {
        const loaded = Object.values(chunkLoaded).reduce((a, b) => a + b, 0);
        const pct = file.size > 0 ? Math.min(99, (loaded / file.size) * 100) : 0;
        setFiles(curr => curr.map((f, i) => (i === idx ? { ...f, progress: pct } : f)));
      };

      const ac = new AbortController();
      abortRef.current[idx] = ac;

      (async () => {
        try {
          let nextChunkIndex = 0;
          const runNext = async () => {
            while (!ac.signal.aborted) {
              const chunkIndex = nextChunkIndex++;
              if (chunkIndex >= totalChunks) break;
              const start = chunkIndex * CHUNK_SIZE;
              const end = Math.min(start + CHUNK_SIZE, file.size);
              const blob = file.slice(start, end);
              const formData = new FormData();
              formData.append("chunk", blob);
              formData.append("uploadId", uploadId);
              formData.append("chunkIndex", String(chunkIndex));
              formData.append("totalChunks", String(totalChunks));
              formData.append("original_filename", file.name);

              await uploadChunkWithRetry(
                formData,
                e => {
                  if (e.lengthComputable) {
                    chunkLoaded[chunkIndex] = e.loaded;
                    updateProgress();
                  }
                },
                ac.signal
              );
            }
          };
          await Promise.all(Array.from({ length: CONCURRENCY }, () => runNext()));

          if (ac.signal.aborted) return;

          const completePayload = {
            uploadId,
            totalChunks,
            mode: "save_db",
            role_id: iFkUserTypeId,
            f_id: "1",
            parent_id: currentPath?.at(-1) ?? file_folders?.fmanager_id ?? null,
            f_scoop_id: scoopId || 0,
            job_id: jobId || 0,
            original_filename: file.name,
            ext: file.name.split(".").pop() || "",
            size: file.size,
          };

          await authApi.post("/saveFileUploadFastComplete", completePayload, {
            headers: { "Content-Type": "application/json" },
            signal: ac.signal,
          });

          setFiles(curr =>
            curr.map((f, i) => (i === idx ? { ...f, status: "done", progress: 100 } : f))
          );

          scoopId && dispatch(getScoopFileFolders(scoopId));
          scoopId && localStorage.setItem("refreshFileCountsForScoop", Date.now().toString());
          jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
          jobId && localStorage.setItem("refreshFileCounts", Date.now().toString());
          clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
          inClientId && dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
          userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
          jobTemplateId &&
            dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
          setTimeout(() => setFiles([]), 2000);
        } catch (err) {
          if (err.name === "CanceledError" || err.name === "AbortError") return;
          console.error("Upload error:", err);
          setFiles(curr => curr.map((f, i) => (i === idx ? { ...f, status: "error" } : f)));
          setTimeout(() => setFiles([]), 2000);
        } finally {
          delete abortRef.current[idx];
        }
      })();
    });
  };

  const handleCreateNewFolder = () => {
    const payload = {
      scoopId,
      parentId: currentPath?.at(-1),
      title: prompt("Please enter folder name"),
    };
    if (payload.title)
      dispatch(Newfoldermake(payload)).then(() => {
        jobId && dispatch(getFileMangerList(new URLSearchParams(jobParams).toString()));
        clientId && dispatch(getFileMangerList(new URLSearchParams({ clientId }).toString()));
        inClientId && dispatch(getFileMangerList(new URLSearchParams({ inClientId }).toString()));
        userId && dispatch(getFileMangerList(new URLSearchParams({ userId }).toString()));
        jobTemplateId &&
          dispatch(getFileMangerList(new URLSearchParams({ jobTemplateId }).toString()));
      });
  };

  function searchNodes(node, searchText, results = []) {
    if (!node) return results;
    const text = searchText.toLowerCase();
    if ((node.original_filename || node.name).toLowerCase().includes(text)) {
      results.push(node);
    }
    if (Array.isArray(node.categories)) {
      for (const child of node.categories) {
        searchNodes(child, searchText, results);
      }
    }
    return results;
  }

  const handleSearch = e => {
    setExpandedFolders(new Set());
    if (e.target.value?.trim()) {
      const modifiedNode = { ...file_folders };
      modifiedNode.name = "";
      setCurrentItems(searchNodes(modifiedNode, e.target.value));
    } else {
      handleFolderDoubleClick(file_folders);
    }
  };

  const isScoopFileManager =
    scoopId && !jobId && !clientId && !userId && !inClientId && !jobTemplateId;

  const findNodeInTree = (node, id) => {
    if (!node) return null;
    if (node.fmanager_id === id) return node;
    if (Array.isArray(node.categories)) {
      for (const child of node.categories) {
        const found = findNodeInTree(child, id);
        if (found) return found;
      }
    }
    return null;
  };

  const originalFilesFolderId = file_folders?.categories?.find(c => c.name === "Original Files")
    ?.fmanager_id;
  const isInsideOriginalFiles =
    isScoopFileManager && originalFilesFolderId && currentPath.includes(originalFilesFolderId);
  const copyableScoopFileIds =
    isInsideOriginalFiles && file_folders
      ? selectedIds.filter(id => {
          const node = findNodeInTree(file_folders, id);
          if (!node || node.f_id !== 1) return false;
          const path = findPathByFmanagerId(file_folders, id);
          return path?.includes(originalFilesFolderId);
        })
      : [];
  const canCopyToAnotherScoop = copyableScoopFileIds.length > 0;

  const handleDestScoopSearch = (_, value) => {
    if (destSearchTimeoutRef.current) clearTimeout(destSearchTimeoutRef.current);
    destSearchTimeoutRef.current = setTimeout(() => {
      const term = (typeof value === "string" ? value : "").trim();
      if (!term) {
        setDestScoopOptions([]);
        return;
      }
      dispatch(globalSearchProjectHeader({ searchKey: term }))
        .unwrap()
        .then(data => {
          setDestScoopOptions(
            (data?.scoopData || []).map(s => ({
              ...s,
              label: `${s.formattedOrderItem}${s.projectName ? ` — ${s.projectName}` : ""}`,
            }))
          );
        })
        .catch(() => setDestScoopOptions([]));
    }, 300);
  };

  const openCopyToScoopModal = () => {
    if (!canCopyToAnotherScoop) {
      window.alert("Select one or more files in the Original Files folder.");
      return;
    }
    setDestScoop(null);
    setDestScoopOptions([]);
    setCopyToScoopOpen(true);
  };

  const handleCopyToAnotherScoop = () => {
    if (!destScoop?.itemId || String(destScoop.itemId) === String(scoopId)) return;
    dispatch(
      copyScoopFilesToScoop({
        sourceScoopId: Number(scoopId),
        targetScoopId: Number(destScoop.itemId),
        fileIds: copyableScoopFileIds,
      })
    ).then(() => {
      setCopyToScoopOpen(false);
      setDestScoop(null);
      setDestScoopOptions([]);
      setSelectedIds([]);
      scoopId && localStorage.setItem("refreshFileCountsForScoop", Date.now().toString());
    });
  };

  return (
    <Box sx={{ py: 2, px: 8 }}>
      <Typography variant="h6" gutterBottom>
        File Manager (Fast Upload): {file_folders?.fileManager_title}
      </Typography>
      {!scoopId && !jobId && !jobTemplateId && !userId && !inClientId && !clientId ? (
        <Typography variant="h6" sx={{ textAlign: "center", mt: 3 }} color="textDisabled">
          No data found
        </Typography>
      ) : (
        !loading && (
          <Box sx={{ p: 2 }} className="whiteBackground">
            <Box
              sx={{ mb: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <Box>
                <IconButton
                  onClick={moveUpDirectory}
                  disabled={currentPath.length === 1}
                  title="Level up"
                >
                  <DriveFolderUpload />
                </IconButton>
                {(!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === "_in")) && (
                  <>
                    <IconButton onClick={() => setIsUploadOpen(p => !p)} title="Upload">
                      <ArrowCircleUp />
                    </IconButton>
                    <IconButton
                      aria-label="Create new folder"
                      onClick={handleCreateNewFolder}
                      title="Create folder"
                    >
                      <CreateNewFolder />
                    </IconButton>
                    <IconButton onClick={() => handleMenuAction("delete")} title="Delete">
                      <Delete />
                    </IconButton>
                  </>
                )}
                {isScoopFileManager && (
                  <Button
                    size="small"
                    variant="outlined"
                    sx={{ ml: 1 }}
                    disabled={!canCopyToAnotherScoop}
                    onClick={openCopyToScoopModal}
                    title={
                      canCopyToAnotherScoop
                        ? "Copy selected files to another scoop"
                        : "Select files in Original Files"
                    }
                  >
                    Copy to Another Scoop
                  </Button>
                )}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography>Selected files: {selectedIds?.length}</Typography>
                <Button onClick={() => setSelectedIds([])}>Clear</Button>
                <TextField
                  onChange={handleSearch}
                  placeholder="Search"
                  sx={{ width: "25ch" }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="end">
                          <Search />
                        </InputAdornment>
                      ),
                    },
                  }}
                  variant="outlined"
                />
              </Box>
            </Box>
            {(!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === "_in")) && isUploadOpen && (
              <Box
                variant="outlined"
                {...getRootProps()}
                sx={{
                  p: 4,
                  border: "2px dashed",
                  borderColor: "grey.700",
                  textAlign: "center",
                  borderRadius: 4,
                  cursor: "pointer",
                  "&:hover": { bgcolor: "action.hover", borderColor: "primary.light" },
                }}
                className="whiteBackground"
              >
                <input {...getInputProps()} />
                <CloudUpload onClick={open} fontSize="large" color="action" />
                <Typography>Drag & drop files here (chunked fast upload)</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  or <br /> <Button onClick={open}>Select Files</Button>
                </Typography>
              </Box>
            )}
            <Box sx={{ mb: 2 }}>
              {files.length > 0 && (
                <>
                  <List>
                    {files.map((entry, idx) => (
                      <ListItem
                        key={idx}
                        secondaryAction={
                          <IconButton edge="end" onClick={() => removeFile(idx)}>
                            <Delete />
                          </IconButton>
                        }
                      >
                        <ListItemText
                          primary={entry.file.name}
                          secondary={`${(entry.file.size / 1024).toFixed(2)} KB — ${entry.status}`}
                        />
                        {(entry.status === "uploading" || entry.status === "done") && (
                          <Box sx={{ width: 120, ml: 2 }}>
                            <LinearProgress variant="determinate" value={entry.progress} />
                          </Box>
                        )}
                      </ListItem>
                    ))}
                  </List>

                  <Box sx={{ textAlign: "center", mt: 2 }}>
                    <Button
                      variant="contained"
                      onClick={uploadAll}
                      disabled={files.every(f => f.status !== "ready")}
                    >
                      <Upload /> Upload (Fast)
                    </Button>
                  </Box>
                </>
              )}
            </Box>

            <Box variant="outlined" sx={{ mb: 2 }} className="whiteBackground">
              <List
                onContextMenu={e => {
                  e.preventDefault();
                  setMenuAnchor({
                    mouseX: e.clientX + 2,
                    mouseY: e.clientY - 6,
                    item: { fmanager_id: currentItems?.at?.(0), isPastable: true },
                  });
                }}
                sx={{ paddingBottom: "100px" }}
              >
                {currentItems?.[0]?.fmanager_id ? (
                  currentItems?.map(item =>
                    item.categories ? renderFolder({ item }) : renderFile({ item })
                  )
                ) : (
                  <Typography
                    color="textDisabled"
                    sx={{ textAlign: "center", p: 3, fontWeight: 500 }}
                  >
                    No items to show
                  </Typography>
                )}
              </List>
              {currentPath?.length <= 1 && scoopId && (
                <>
                  <Divider />
                  <Typography variant="h5" p={2}>
                    Linguist Delivery
                  </Typography>
                  <List sx={{ paddingBottom: "100px" }}>
                    {jobs?.length ? (
                      jobs?.map(item =>
                        item.categories
                          ? renderFolder({ item, isJobView: true })
                          : renderFile({ item, isJobView: true })
                      )
                    ) : (
                      <Typography
                        color="textDisabled"
                        sx={{ textAlign: "center", p: 3, fontWeight: 500 }}
                      >
                        No items to show
                      </Typography>
                    )}
                  </List>
                </>
              )}

              <Menu
                open={menuAnchor !== null}
                onClose={handleCloseMenu}
                anchorReference="anchorPosition"
                anchorPosition={
                  menuAnchor !== null
                    ? { top: menuAnchor.mouseY, left: menuAnchor.mouseX }
                    : undefined
                }
              >
                {!menuAnchor?.isJobView ? (
                  menuAnchor?.item?.isPastable ? (
                    <>
                      {!clientId && !userId && !inClientId && (
                        <MenuItem
                          onClick={() => handleMenuAction("paste")}
                          disabled={!copiedIds?.length}
                        >
                          Paste
                        </MenuItem>
                      )}
                      {(!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === "_in")) && (
                        <MenuItem onClick={handleCreateNewFolder}>New folder</MenuItem>
                      )}
                      <MenuItem onClick={() => handleMenuAction("refresh")}>Refresh</MenuItem>
                    </>
                  ) : (
                    <>
                      {menuAnchor?.item?.categories ? (
                        <>
                          <MenuItem onClick={() => handleMenuAction("open")}>Open</MenuItem>
                          {!clientId && !userId && !inClientId && (
                            <MenuItem onClick={() => handleMenuAction("rename")}>Rename</MenuItem>
                          )}
                          {!clientId && !userId && !inClientId && (!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === "_in")) && (
                            <MenuItem onClick={() => handleMenuAction("copyFolder")}>Copy</MenuItem>
                          )}
                        </>
                      ) : (
                        <>
                          {jobId && (
                            <MenuItem onClick={() => handleMenuAction("rename")}>Rename</MenuItem>
                          )}
                          {(!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === "_in")) && !clientId && !userId && !inClientId && (
                            <MenuItem onClick={() => handleMenuAction("copy")}>Copy</MenuItem>
                          )}
                          {isScoopFileManager &&
                            isInsideOriginalFiles &&
                            !menuAnchor?.item?.categories &&
                            menuAnchor?.item?.f_id === 1 && (
                              <MenuItem
                                onClick={() => {
                                  handleCloseMenu();
                                  openCopyToScoopModal();
                                }}
                              >
                                Copy to Another Scoop
                              </MenuItem>
                            )}
                          <MenuItem>
                            <FilePropertiesDialog item={menuAnchor?.item} />
                          </MenuItem>
                        </>
                      )}
                      <MenuItem onClick={() => handleMenuAction("download")}>Download</MenuItem>
                      <MenuItem onClick={() => handleMenuAction("fast_download")}>Fast Download</MenuItem>
                      {!clientId && !userId && !inClientId && (!jobId || (iFkUserTypeId === 2 && sourceTargetType === "_out") || (iFkUserTypeId === 1 && sourceTargetType === "_in")) && (
                        <MenuItem onClick={() => handleMenuAction("delete")}>Delete</MenuItem>
                      )}
                    </>
                  )
                ) : (
                  <>
                    <MenuItem onClick={() => handleMenuAction("download")}>Download</MenuItem>
                    <MenuItem onClick={() => handleMenuAction("fast_download")}>Fast Download</MenuItem>
                  </>
                )}
              </Menu>
            </Box>
          </Box>
        )
      )}

      <PopupModal
        open={copyToScoopOpen}
        handleClose={() => setCopyToScoopOpen(false)}
        title="Copy to Another Scoop"
        maxWidth="sm"
        actions={
          <>
            <Button onClick={() => setCopyToScoopOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              disabled={!destScoop || String(destScoop.itemId) === String(scoopId)}
              onClick={handleCopyToAnotherScoop}
            >
              Copy
            </Button>
          </>
        }
      >
        <Autocomplete
          options={destScoopOptions}
          value={destScoop}
          onChange={(_, val) => setDestScoop(val)}
          onInputChange={handleDestScoopSearch}
          getOptionLabel={opt => opt?.label || opt?.formattedOrderItem || ""}
          isOptionEqualToValue={(opt, val) => opt?.itemId === val?.itemId}
          filterOptions={x => x}
          renderInput={params => (
            <TextField
              {...params}
              label="Search scoop"
              placeholder="Order number or scoop ID"
            />
          )}
        />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {copyableScoopFileIds.length} file(s) will be copied to the destination scoop&apos;s
          Original Files folder.
        </Typography>
      </PopupModal>

      <Backdrop sx={theme => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default FileManagerFastUpload;
